import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { Props } from './NotesButtonAndDropdown';
// import { ChatStoreSlice } from '../../../Chat/redux/types'; // Chat component removed
import { getChatHasMessage } from '../../../Notes/redux/unreadChats/selectors';

export type StateProps = Pick<Props, 'hasNewMsg'>;
export type DispatchProps = Pick<Props, never>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  any // ChatStoreSlice removed
> = state => ({
  hasNewMsg: getChatHasMessage(state),
});
const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {};

export default connect(mapStateToProps, mapDispatchToProps);
